import { Button } from "components/button";
import { Icon } from "components/icon/Icon";
import { Text } from "components/text";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

interface DisabledBundleButtonProps {
  label: string;
  /** When present, the disabled button shows an explanatory tooltip. */
  tooltip?: { title: string; body: string };
}

export const DisabledBundleButton = ({
  label,
  tooltip,
}: DisabledBundleButtonProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="inline-flex">
        <Button
          variant="tertiary"
          icon="layers"
          iconPosition="left"
          label={label}
          disabled
          testId="bundle-button"
        />
      </span>
    </TooltipTrigger>
    {tooltip ? (
      <TooltipContent
        side="bottom"
        className="max-w-xs border-secondary-200 bg-white text-secondary-800 shadow-md"
      >
        <div className="flex items-start gap-2">
          <Icon
            name="layers"
            size="small"
            iconClassName="mt-0.5 shrink-0 text-secondary-400"
          />
          <span className="flex flex-col gap-0.5">
            <Text as="span" variant="label">
              {tooltip.title}
            </Text>
            <Text as="span" variant="muted">
              {tooltip.body}
            </Text>
          </span>
        </div>
      </TooltipContent>
    ) : null}
  </Tooltip>
);
